import React from "react";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

/**
 * "Version" column header of the Adapters table. Many adapters share one name
 * (one per distinct content), so the header explains how the version is named.
 */
export default function AdapterVersionHeader() {
  const [t] = useTranslation("global");
  return (
    <span>
      {t("adapter.version")}{" "}
      <Tooltip title={t("adapter.versionHelp")} overlayStyle={{ maxWidth: 420 }}>
        <FontAwesomeIcon
          icon={faCircleInfo}
          aria-label={t("adapter.versionHelp")}
          data-testid="adapter-version-help"
        />
      </Tooltip>
    </span>
  );
}
